import { Observable } from 'rxjs';

const lanternUrl = (url: string): string => process.env.REACT_APP_API_URL + url;
const coreApiUrl = (url: string): string => process.env.REACT_APP_CORE_API_URL + url;

export default class AuthClient {
  // core-frontend links to /sso-login/ with a one-time login code instead of the session key
  // (core-backend docs/auth_refactor.md §11). It works once, within 60 seconds, and only for this app.
  // Resolves to the session key, or null when the code can't be redeemed.
  public static redeemLoginCode(code: string): Promise<string | null> {
    return fetch(coreApiUrl('/v2/login-codes/redeem'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      body: JSON.stringify({ code, audience: 'reports' }),
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => data?.sessionKey ?? null)
      .catch(() => null);
  }

  // The signed-in user and session for a session key, the same shape the login form stores as session data.
  // Resolves to null when the key is not valid.
  public static signInWithSessionKey(sessionKey: string): Promise<any | null> {
    return fetch(coreApiUrl('/api/signin'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      body: JSON.stringify({ sessionKey }),
    })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);
  }

  public static login(request: any): Observable<any> {
    const requestBody = { body: JSON.stringify(request) };
    const requestMethod = { method: 'POST' };
    return new Observable((observer) => {
      fetch(lanternUrl('/auth/login'), {
        ...requestMethod,
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          pragma: 'no-cache',
          'Cache-Control': 'no-cache',
        },
        ...requestBody,
      })
        .then((response) => {
          if (response.ok) {
            const contentType = response.headers.get('content-type');
            if (
              !contentType ||
              contentType.indexOf('application/json') === -1
            ) {
              observer.next(response);
              observer.complete();
            } else {
              response.json().then((data) => {
                observer.next(data);
                observer.complete();
              });
            }
          } else {
            observer.error();
            observer.complete();
          }
        })
        .catch((err) => observer.error(err));
    });
  }
}
